import React from 'react';
import { useDispatch } from 'react-redux';
import { Layout } from 'antd';
import useDetectDevice from '../../hook/useDetectDevice';

import TopMenu from '../TopMenu/TopMenu';
import AppRouter from '../../routers/routes';
import MenuLeft from '../MenuLeft';
import useAuth from '../../hook/useAuth';
import Loading from '../../commons/components/Loading';
import useSocket from '../../hook/useSocket';
import { NOTIFICATION_TYPE } from '../../commons/constants/constants';
import CopyRight from '../CopyRight';
import HotspotOverview from '../../commons/components/HotspotOverview';
import './styles.scss';

import './styles/index.scss';

const { Content } = Layout;

const Admin: React.FC = () => {
  const { user } = useAuth();
  useDetectDevice();
  const dispatch = useDispatch();

  useSocket({
    scriptURL: `${process.env.PUBLIC_URL}/shareWorker/worker.js`,
    options: 'virtualtour-admin-socket-worker-v1',
    onMessage: (recieveMessage: MessageEvent) => {
      try {
        const { data } = recieveMessage;
        if (data.type === NOTIFICATION_TYPE.REFRESH_TOURS) {
          dispatch.tourEntity.loadById(data.data);
        } else if (data.type === NOTIFICATION_TYPE.REFRESH_SCENE) {
          dispatch.sceneEntity.loadById(data.data);
        }
      } catch (e) {
        console.error(e);
      }
    },
    user,
  });

  return user ? (
    <>
      <MenuLeft />
      <div id="content-wrapper" className="d-flex flex-column">
        <TopMenu />
        <div id="content">
          <Layout className="container-fluid position-relative pt-4 pb-4 h-100">
            <Content>
              <AppRouter />
            </Content>
            <CopyRight />
          </Layout>
        </div>
      </div>
      <HotspotOverview />
    </>
  ) : (
    <Loading loading />
  );
};

export default React.memo(Admin);
